// How this account's region writes dates and times on a Calendar board (Fixes 9): the rule a sheet uses
// (shared/region.ts), from the time zone the account's browser says it is in, read once. A UK account sees 28/10/2026,
// Wed 28 Oct and 14:30; a US one 10/28/2026, Wed, Oct 28 and 2:30 PM, whatever language the browser speaks. The
// editor, the grid, the month, the quick add and the phone's list all write them through here.

import { clockText, dateText, dayLabel, viewTitle, whenLabel, type AgendaView, type Shown } from "../../../shared/agenda";
import { shortDay } from "../../../shared/days";
import { repeatWords, type RepeatRule } from "../../../shared/repeat";
import { regionDayFirst } from "../../../shared/region";
import { startsOn } from "./state";

/** Dates day first, and times on the 24-hour clock with them. */
export const dayFirst = regionDayFirst();
export const h24 = dayFirst;

/** A clock time, minutes after midnight: "14:30" or "2:30 PM". */
export const timeText = (min: number) => clockText(min, h24);
/** A day in a date field: 28/10/2026 or 10/28/2026. */
export const dateField = (day: string) => dateText(day, dayFirst);
/** "Wed 28 Oct" or "Wed, Oct 28". */
export const dayText = (day: string) => dayLabel(day, dayFirst);
/** "Today", "Friday", "Fri 6 Nov" or "Fri, Nov 6". */
export const shortDayText = (day: string, today: string) => shortDay(day, today, dayFirst);
/** When an event is, in words. */
export const whenText = (s: Shown, day?: string) => whenLabel(s, day, dayFirst);
/** What a view shows, as its header says it. */
export const viewText = (view: AgendaView, at: string) => viewTitle(view, at, startsOn, dayFirst);
/** How an event repeats, in words. */
export const repeatText = (rule: RepeatRule, first: string) => repeatWords(rule, first, dayFirst);
